import { environment } from '../../../environments/environment';
export class ApiUrlConstants {
  public static configurationApiUrl = environment.apiUrl + '/admin/V1/';
  public static shippingApiUrl = environment.apiUrl + '/shipping/V1/';
  public static paymentApiUrl = environment.apiUrl + '/payment/v1/';
  public static addressApiUrl = environment.apiUrl + '/address/V1/';
  public static customerServiceApiUrl = environment.apiUrl + '/customer/v1/';
  public static customerServiceV2ApiUrl = environment.apiUrl + '/customerv2/V1/';
  public static accountApiUrl = environment.apiUrl + '/account/V1/';
  public static productApiUrl = environment.apiUrl + '/product';
  public static orderApiUrl = environment.apiUrl + '/order';
  public static taxApiUrl = environment.apiUrl + '/tax';
  public static myCustomerReportUrl = environment.apiUrl + '/report/V1/';
  public static auditApiUrl = environment.apiUrl + '/audit/v1/';
  public static cmsApiUrl = environment.apiUrl + '/content/v1';
  public static communicationApiUrl = environment.apiUrl + '/communication/v1/';
  public static reportApiUrl =  environment.apiUrl  + '/' +environment.reportApi + '/V2';
  public static batchApiUrl = environment.apiUrl + '/batch/v1/';
  public static googleMapsUrl = 'https://www.google.com/maps/place/';
  public static reportTitanApiUrl = environment.apiUrl + '/reporttitan/V1/';
  public static portalUrl = environment.portalUrl;
  public static diservice =environment.apiUrl +'/dataintegration/V1/'
  public static schedular = environment.apiUrl +'/scheduler/v1/'
  public static bonusEngineUrl = environment.apiTBEUrl;
  public static reportTitanBaseApiUrl = environment.apiUrl + '/reporttitan/';
  public static enrollmentApigwUrl = environment.apiUrl + '/enrollment/V1/';
  public static manageAccountApiGwUrl = environment.apiUrl + '/manage-account/V1/';
}



// WEBPACK FOOTER //
// ./src/app/common/constants/api.constants.ts